<template>
  <v-app>
    <div class="row">
      <div class="col-12">
        <div class="card ">
          <div class="card-header">
            <div class="card-title pt-3 px-3 d-flex justify-content-between">
              <div class="breadcrumb-left">
                <h4>
                  Manage Attachment
                </h4>
                <div class="breadcrumb-sub-header">
                  <router-link to="/dashboard">Dashboard </router-link>\  Attachment
                </div>
              </div>
              <div class="breadcrumb-right">
                <v-btn @click="addAttachment()"
                       class="mt-4 btn btn-primary  mr-1"
                       dark>
                  <i class="fa fa-plus"></i>
                  Add Attachment
                </v-btn>

              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-stripe">
                <thead>
                  <tr class="px-3">
                    <th>Title</th>
                    <th>Type</th>
                    <th>Downloadable</th>
                    <th class="pr-3 text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-show="attachments.length > 0" v-for="(attachment, i) of attachments" :key="i">
                  <td>
                    <a href="#" class="mr-2" @click="manageAttachment(attachment)"> {{ attachment.title }}</a>
                    <i class="fas fa-circle"
                       :class="attachment.is_active?'dot-active':'dot-warning'"></i>
                  </td>
                  <td>
                    {{ attachment.type }}
                  </td>
                  <td class="">
                      <span> <i
                          :class="attachment.is_downloadable?'text-success fas fa-check':'text-danger fas fa-ban'"></i></span>
                  </td>
                  <td class="pr-0 text-center">
                    <b-dropdown
                        size="sm"
                        variant="link"
                        toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                        no-caret
                        right
                        no-flip
                    >
                      <template v-slot:button-content>
                        <slot>
                                                        <span>
                                                                    <i class="flaticon-more-1"></i>
                                                                  </span></slot>
                      </template>
                      <!--begin::Navigation-->
                      <div class="navi navi-hover ">
                        <b-dropdown-text tag="div" class="navi-item">
                          <a href="#" class="navi-link"
                             @click="deleteAttachment(attachment.id)">
                                                            <span class="navi-icon">
                                                              <i class="fas fa-trash"></i>
                                                            </span>
                            <span class="navi-text">  Delete</span>
                          </a>
                        </b-dropdown-text>

                      </div>
                      <!--end::Navigation-->
                    </b-dropdown>

                  </td>
                </tr>
                  <tr v-if="attachments.length == 0">
                    <td colspan="4" class="text-center">
                      <strong>No items added.</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <attachment-create-and-update
        ref="attachment"
        :dialog="dialog" :resource_id="resource_id"
        @refresh_list="getAttachments"></attachment-create-and-update>
    <!--    <rack-create-and-update ref="rack" @close_dialog="closeRackDialog"></rack-create-and-update>-->
  </v-app>
</template>
<script>
import CreateAndUpdate from "./CreateAndUpdate"
import AttachmentService from "@/core/services/library/resource/AttachmentService";
import AttachmentCreateAndUpdate from "./CreateAndUpdate";

const attachmentService = new AttachmentService();

export default {
  name: "Index",
  components: {AttachmentCreateAndUpdate},
  data() {
    return {
      search: {},
      attachments: [],
      dialog: false,
      page: 1,
      total: null,
      perPage: null,
      active_statuses: [
        {title: 'Active', value: "active"},
        {title: 'In Active', value: "in_active"}
      ],
    }
  }, computed: {
    resource_id() {
      return this.$route.params.id;
    }
  },
  mounted() {
    this.getAttachments()
  },
  methods: {
    getAttachments() {
      this.dialog = false
      attachmentService.byResource(this.resource_id).then(response => {
        this.attachments = response.data
        console.log(this.attachments)
      })
    },
    deleteAttachment(id) {
      this.$confirm({
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        callback: confirm => {
          if (confirm) {
            attachmentService.delete(id).then(response => {
              this.getAttachments();
            })
          }
        }
      });
    },
    deleteRack(shelfId, id) {
      this.$confirm({
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        callback: confirm => {
          if (confirm) {
            attachmentService.delete(shelfId, id).then(response => {
              this.$snotify.success("Attachment deleted successfully")
              this.getAttachments();
            })
          }
        }
      });
    }, addAttachment() {
      this.dialog = true
    },
    editAttachment(resource) {
      this.dialog = true
      this.$refs['attachment'].editAttachment(this.resource_id)
    },
    closeDialog() {
      this.dialog = false
      this.getAttachments();
    },
    manageAttachment(resource) {
      this.$refs['attachment'].manageAttachment(resource)

    }
  }
}
</script>

<style scoped>
</style>